import PlayCanvasService from "../../../services/PlayCanvasService/PlayCanvasService";
import { changeShowModal } from "../../reducers/app/appReducer";
import { resetDataScene, setActiveObjectId, setDataHistory } from "../../reducers/ui/uiReducer";
import { loadObjectSceneData } from "./objectHandlers";
import {
  ISelectItemObjectData,
  SelectedObjectData,
} from "../../reducers/ui/uiTypes";
import { AppStore } from "../../store";

// Register global selection handler
// Note: We re-register on each scene load because PlayCanvas engine may be recreated
export const registerSelectionHandler = (store: AppStore) => {
  PlayCanvasService.onSelectedSimple(evt => {
    if (!evt || evt.id == null) {
      store.dispatch(setActiveObjectId(null));
      // Clear list_id from URL when clicking on empty space
      const currentUrl = new URL(window.location.href);
      if (currentUrl.searchParams.has('list_id')) {
        currentUrl.searchParams.delete('list_id');
        window.history.pushState({}, '', currentUrl.toString());
      }
      return;
    }

    const state = store.getState();
    let selectedUiId: string | null = null;

    // direct UI id match
    const direct = (state.ui.selectObjects || {})[String(evt.id)];

    if (direct) {
      selectedUiId = String(evt.id);
      store.dispatch(setActiveObjectId(selectedUiId));
    } else {
      // map realId -> uiId from selectObjects
      const entries = Object.entries(state.ui.selectObjects || {});
      const found = entries.find(([, val]: [string, any]) => val?.realId === Number(evt.id));

      if (found) {
        const [uiId] = found as [string, any];
        selectedUiId = uiId;
        store.dispatch(setActiveObjectId(uiId));
      } else {
        store.dispatch(setActiveObjectId(null));
        return;
      }
    }

    // Update URL to show ObjectOptionsItem
    if (selectedUiId) {
      const currentUrl = new URL(window.location.href);
      currentUrl.searchParams.set('list_id', selectedUiId);
      window.history.pushState({}, '', currentUrl.toString());
    }
  });
};

export const loadActualDataScene = (data: {
  selectData: SelectedObjectData;
}) => {
  return async (store: AppStore) => {
    const { selectData } = data;

    // Load asset manager and register selection handler globally
    await PlayCanvasService.loadAssetManager();
    registerSelectionHandler(store);

    store.dispatch(changeShowModal({ nameModal: "loader", stateModal: true }));
    await PlayCanvasService.clearScene();

    for (const [id, data] of Object.entries<ISelectItemObjectData>(
      selectData
    )) {
      if (!data.glbData) continue;
      await PlayCanvasService.loadAssetWithParams(
        id,
        data.glbData.url,
        data.glbData.transform
      );
    }

    store.dispatch(changeShowModal({ nameModal: "loader", stateModal: false }));

    // Kick off image renders to populate RenderPreview for each object
    for (const [id, data] of Object.entries<ISelectItemObjectData>(
      selectData
    )) {
      loadObjectSceneData(
        {
          productId: id,
          loadGLB: false,
          replaceGLB: false,
        },
        data
      )(store);
    }
  };
};

export const resetDataSceneHandler = () => {
  return async (store: AppStore) => {
    store.dispatch(resetDataScene());
    store.dispatch(setDataHistory({ dataHistory: null }));
  };
};
